import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import {createRoot} from 'react-dom/client';

import {CssBaseline} from '@mui/material';
import {GoogleOAuthProvider} from '@react-oauth/google';
import App from './App';
import store from "./store";
import {Provider} from "react-redux";

const node = document.getElementById('root');

if (!node) {
    throw new Error('Root container missing in public/index.html');
}

const root = createRoot(node);

root.render(
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID!}>
        <Provider store={store}>
            <CssBaseline/>
            <App/>
        </Provider>
    </GoogleOAuthProvider>,
);
